module.exports = __webpack_public_path__ + "img/404.ac337b38.svg";